module.exports = {
  FreeResponse: {
    PluginName: "Respuesta Libre",
    content_box_name: "Contenedor  ",
    Statement: "Esta es una pregunta de respuesta abierta. Puedes escribir la descripción aquí.",
    Question: "Pregunta",
    Feedback: "Explicación",
    FeedbackMsg:
      "Aquí puedes incluir una explicación acerca de la respuesta. Puedes desactivar esta opción en la barra de herramientas.",
    TrueFeedbackMsg:
      "Aquí puedes añadir una explicación sobre la respuesta correcta. Puedes desactivar esta opción en la barra de herramientas.",
    FalseFeedbackMsg:
      "Aquí puedes añadir una explicación sobre la respuesta incorrecta. Puedes desactivar esta opción en la barra de herramientas.",
    ShowFeedback: "Mostrar Explicación",
    Answer: "Respuesta",
    Placeholder: "Escribe aquí tu respuesta.",
    PlaceholderEditor: "El alumno escribirá aquí su respuesta",
    TooMany: "Has introducido un texto demasiado extenso. No se corregirá.",
    TooFew: "Por favor, introduce al menos el número mínimo de caracteres requerido.",
    MinLength: "Longitud Mínima",
    MaxLength: "Longitud Máxima",
    MaxInput: "Máximo de caracteres",
    Characters: "Ignorar mayúsculas y tildes",
    Correct: "Respuesta Exacta",
    Config: "Configuración",
    FeedbackColor: "Color",
    notCount: "Este ejercicio no añade puntos a la nota",
    InputAppearance: "Apariencia del Campo de Respuesta",
    InputBackground: "Color de Fondo",
    InputHeight: "Altura del Campo",
    InputTypography: "Estilo de Texto",
    InputFont: "Tipo de Letra",
    InputFontSize: "Tamaño de Letra",
    InputTextColor: "Color de Texto",
    InputBorder: "Estilo de Borde",
    InputBorderColor: "Color de Borde",
    InputBorderWidth: "Grosor de Borde",
    InputBorderRadius: "Redondez de Esquinas",
    CheckAnswerText: "Texto del Botón Verificar Respuesta",
    TryAgainText: "Texto del Botón Intentar de Nuevo",
    SeeAnswerText: "Texto del Botón Ver Respuesta",
    ButtonStyle: "Estilo del Botón",
    ButtonBackground: "Color de Fondo del Botón",
    ButtonTextColor: "Color de Texto del Botón",
    ButtonBorderColor: "Color de Borde del Botón",
    ButtonBorderWidth: "Grosor del Borde del Botón",
    ButtonBorderRadius: "Radio de Borde del Botón",
    ButtonPadding: "Espaciado del Botón",
    ButtonFontSize: "Tamaño de Fuente del Botón",
    ButtonFontWeight: "Peso de Fuente del Botón",
    ButtonHoverBackground: "Color de Fondo al Pasar el Ratón",
    tryAgain: "Inténtalo de nuevo",
    checkAnswer: "Comprueba la respuesta",
    seeAnswer: "Ver Respuesta",
  },
};
